// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NHTU","col":"styles_col__2Iay2"};